export default "__VITE_ASSET__pZHDcDsg__"